import React from 'react';
import PropTypes from 'prop-types';
import { Tab } from 'semantic-ui-react';
import 'PointOfSale/styles/components/cepCard.less';

const Tabs = ({ panes, activeTabIndex, changeTab }) => {
  return (
    <Tab
      menu={{ secondary: true, pointing: true }}
      panes={panes}
      activeIndex={activeTabIndex}
      onTabChange={changeTab}
    />
  );
};

Tabs.propTypes = {
  panes: PropTypes.array,
  activeTabIndex: PropTypes.number,
  changeTab: PropTypes.func,
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/component/Tabs.js